
const defaultState = function () {
  return {
    mode: 0,
    listIndex: -1,
    currentPage: 0,
    tdLists: [],
    totalCount: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      setItemComponentType: {
        type: 'MultiSelector',
        title: 'セット品目構成区分',
        property: '',
        display: false,
        value: '',
        options: [
          { code: '0', name: '親' },
          { code: '1', name: '売上' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/masterComponent.js